/**
 * Styled Components - Created by gustavomedina on 02/05/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import {
  RED,
  GRAY_DARK,
  GRAY_LIGHT,
  BLUE,
  WHITE
} from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  min-height: calc(100vh - 200px);
  .errorLabel.is-visible {
    display: block;
  }
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    min-height: 0px;
  }
`

export const EmptyContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  gap: var(--spacing-24);
  width: 100%;
  max-width: 402px;
  min-height: calc(100vh - 200px);
  padding: var(--spacing-128) 0;

  @media (max-width: 768px) {
    padding: var(--spacing-80) var(--spacing-16);
  }

  #emptyIconFrame {
    flex-shrink: 0;
    height: 64px;
    position: relative;
    width: 64px;
  }
  #emptyTitle {
    color: var(--neutral-darkest);
    font: 600 24px/30px var(--font-barlow-semi-condensed);
    letter-spacing: 0.4px;
    text-align: center;
  }
  #emptyMessage {
    color: var(--neutral-body);
    font: 400 14px/22px var(--font-inter);
    text-align: center;
    @media (max-width: 768px) {
      padding-inline: 22px;
    }
  }
`

export const PageContent = styled.div`
  position: relative;
  background-color: var(--neutral-lightest-block);
  max-width: 1440px;
  margin: 0 auto;
  padding-inline: var(--spacing-48);
  @media (max-width: 768px) {
    padding-inline: var(--spacing-16);
  }
`

export const SideBar = styled.div`
  min-width: 340px;
  max-width: 360px;
  margin-left: 16px;
  margin-bottom: var(--spacing-16);
  position: sticky;
  top: 110px;
  #summary {
    border: var(--border-regular) solid var(--neutral-border-light);
    background: var(--neutral-white);
    padding: var(--spacing-24);
  }
  .errorLabel {
    display: none;
    color: var(--accent-red);
    text-align: center;
    font: 600 13px/22px var(--font-inter);
    margin-top: var(--spacing-16);
  }
  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    max-width: 100%;
    #summary {
      padding-top: var(--spacing-8);
    }
  }
`

export const EmptyTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: center;
`

export const EmptyIcon = styled.img`
  height: 60px;
  left: -2px;
  max-width: none;
  position: absolute;
  top: -2px;
  width: 62px;
`

export const EmptyActions = styled.div`
  align-items: center;
  display: flex;
  gap: var(--spacing-16);
  width: 100%;

  @media (max-width: 768px) {
    align-items: stretch;
    flex-direction: column;
    gap: var(--spacing-12);
  }
`

export const OptionMenu = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  padding-top: 8px;
`

export const Content = styled.div`
  width: 80%;
  min-width: 0;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`

export const SummaryTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
  margin-bottom: 20px;
`

export const Divider = styled.div`
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  border: 1px solid ${GRAY_LIGHT};
  margin-bottom: 10px;
`

export const CodeDivider = styled.div`
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  border: 1px solid ${GRAY_LIGHT};
  margin-bottom: 0;
`

export const OrderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;

  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
`

export const TotalOrderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: 600;
  line-height: 27px;
  margin-block: 36px 34px;
  #topTitle {
    color: var(--neutral-darkest);
    margin-top: var(--spacing-12);
    font: 700 40px/42px var(--font-barlow-semi-condensed);
  }
  .breadCrumbsDiv {
    padding: 0;
  }
  @media (max-width: 768px) {
    #topTitle {
      letter-spacing: 0.4px;
      font: 600 24px/30px var(--font-barlow-semi-condensed);
    }
  }
`

export const ScreenTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
`

export const ButtonWrapper = styled.div`
  margin-top: 16px;
`

export const CheckoutIcon = styled(Icon)`
`

export const InputWrapper = styled.div`
  .ant-input {
    margin-bottom: 26px;
    height: 40px;
    border-radius: 0;
    color: #bebebe;
    font-size: 16px;
    line-height: 22px;
  }
`

export const ZipCodeInputWrapper = styled.div`
  margin-bottom: 10px;
  input {
    border-radius: 0;
  }
  .ant-btn {
    border-radius: 0;
    background-color: ${BLUE};
    border-color: ${BLUE};
    &:hover {
      background-color: ${BLUE};
      border-color: ${BLUE};
    }
  }
`

export const CollapseWrapper = styled.div`
  margin-bottom: 10px;
  .ant-collapse .ant-collapse-item .ant-collapse-header {
    display: flex;
    flex-direction: row;
    color: #5f6062;
    font-size: 12px;
    letter-spacing: 0.15px;
    line-height: 16px;
    padding: 14px 0 12px 0;
  }
  .ant-collapse .ant-collapse-item .ant-collapse-header .arrow {
    position: absolute;
    left: 95%;
    display: inline;
    width: auto;
  }

  .ant-collapse-borderless .ant-collapse-item .ant-collapse-content {
    padding: 0;
  }
`

export const CartList = styled.ul`
  padding: 0;
  height: 100%;
`

export const menuStyle = { width: '100%', marginLeft: -24, paddingTop: 52 }

export const ModalHeader = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 100%;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const CloseIcon = styled.img`
  cursor: pointer;
`

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 24px;
  justify-content: flex-end;
`

export const ContinueButton = styled(Button)`
  background: ${BLUE};
  border: none;
  height: 40px;
  color: ${WHITE};
  max-width: 140px;
  transition: all 0.25s;
  width: 100%;
  &:hover {
    border: 1px solid ${RED};
  }
`

export const StoreInfo = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 42px;
  margin-bottom: 24px;
`

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const MaintenanceLayout = styled.div`
  min-height: calc(100vh - 192px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${WHITE};
  flex-flow: column;
  padding: 64px 18px;
`

export const MaintenanceImage = styled.img`
  max-width: 440px;
  width: 100%;
`

export const MaintenaceLink = styled.div`
  margin-top: 38px;
  box-shadow: 0px 2px 5px -3px black;
  border-radius: 53px;
  padding: 8px 14px;
  background: white;
  color: #577395;
  font-weight: bold;
  font-family: Avenir;
  transition: all 0.25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ConfirmTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir-Medium;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  display: flex;
  align-items: center;
`

export const ConfirmIcon = styled(Icon)`
  margin-right: 18px;
`

export const ModalBody = styled.div`
  color: ${GRAY_DARK};
  font-size: 15px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 22px 0 28px -38px;
`

export const cancelButtonStyle = {
  background: BLUE,
  border: 'none',
}

export const FloatingBottom = styled.div<{ $visible?: boolean }>`
  display: none;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  padding: 16px;
  z-index: 8;
  border-top: 1px solid var(--neutral-border-light);
  background: var(--neutral-white);
  box-shadow: 0 -4px 12px 0 rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease-in-out, opacity 0.2s ease-in-out;
  @media (max-width: 768px) {
    display: block;
    transform: ${({ $visible }) => ($visible ? 'translateY(0)' : 'translateY(110%)')};
    opacity: ${({ $visible }) => ($visible ? '1' : '0')};
    pointer-events: ${({ $visible }) => ($visible ? 'all' : 'none')};
  }
  #grandTitle {
    color: var(--neutral-body);
    font: 400 12px/18px var(--font-inter);
  }
  #grandTotal {
    color: var(--neutral-darkest);
    font: 600 20px/26px var(--font-barlow-semi-condensed);
    letter-spacing: 0.6px;
  }
  .errorLabel {
    display: none;
    color: var(--accent-red);
    text-align: center;
    font: 600 14px/22px var(--font-inter);
    margin-bottom: var(--spacing-4);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ShoppingCartPageV2/styledComponents.tsx